import { supabase } from "@/lib/supabase/supabaseClient";
import { GetAllCrmProjectsListProps } from ".";


// TODO CHECK ERROR
export const getAllCrmProjectsList = async ({
  whereCrmSystems = [],
  orgId,
}: GetAllCrmProjectsListProps) => {
  const res = await supabase
    .from("crm_project")
    .select("*,crm!inner(*,organisation_crm!inner(*))")
    .filter("crm.crm_system", "in", `(${whereCrmSystems.join(",")})`)
    .or(`organisation_id.eq.${orgId}`, {
      referencedTable: "crm.organisation_crm",
    })
    .throwOnError();
  return res.data;
};
